exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".QiSubProductTypeSelect+.select2-container{margin-left:28px!important;width:60%!important}.QiSubProductTypeSelect{display:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Master/Product/ProductUpdate.vue
// module id = 1103
// module chunks = 0